import {Injectable} from "@angular/core";
import {AbstractSQLService} from "./AbstractSQLService";
import {UnidadeMedida} from "../../../domain/UnidadeMedida";

@Injectable()
export class UnidadeMedidaSQLService extends AbstractSQLService<UnidadeMedida>{
    nomeTabela = "unidade_medida"
  agenciavel = false
}
